module.exports = __webpack_public_path__ + "static/media/post-11.86a3d856.jpg";